import React from 'react';
import Hls from 'hls.js';
import { Sensor } from '../services/api';

interface StreamOverlayProps {
  hlsUrl: string;
  selectedSensor: Sensor | null;
  onClose: () => void;
}

const StreamOverlay: React.FC<StreamOverlayProps> = ({ hlsUrl, selectedSensor, onClose }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 99999, backgroundColor: 'rgba(0,0,0,0.4)' }}
      onClick={onClose}
    >
      <div
        className="rounded-lg shadow-2xl overflow-hidden border border-gray-600"
        style={{ width: '720px', maxWidth: '90vw', backgroundColor: 'rgba(17,24,39,0.8)', backdropFilter: 'blur(8px)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center px-3 py-2" style={{ backgroundColor: 'rgba(31,41,55,0.9)' }}>
          <span className="text-white text-sm">{selectedSensor?.name} - {selectedSensor?.location_name}</span>
          <button
            className="text-gray-400 hover:text-white text-xl font-bold leading-none"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <video
          ref={(el) => {
            if (!el) return;
            if (Hls.isSupported()) {
              const hls = new Hls({ liveDurationInfinity: true, enableWorker: true, lowLatencyMode: true });
              hls.loadSource(hlsUrl);
              hls.attachMedia(el);
              hls.on(Hls.Events.MANIFEST_PARSED, () => { el.play().catch(() => {}); });
              const observer = new MutationObserver(() => {
                if (!document.contains(el)) { hls.destroy(); observer.disconnect(); }
              });
              observer.observe(document.body, { childList: true, subtree: true });
            } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
              el.src = hlsUrl;
              el.play().catch(() => {});
            }
          }}
          autoPlay
          muted
          playsInline
          className="w-full"
        />
      </div>
    </div>
  );
};

export default StreamOverlay;
